import { Box, Button, TextField, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { Controller, useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import { BookingDataContext } from './AddBooking'
import { BookingService } from '../Service'

const ApplyDiscount = ({setOpenDiscountModal}) => {
    const { dateTimeSlot, bookingInProgressData, setBookingInProgressData } = useContext(BookingDataContext);
    const { control, watch, handleSubmit, formState: { errors } } = useForm({
        mode: 'onChange',
        defaultValues: {
            couponCode: '',
        },
    })
    const subitCouponDiscount = async (data) => {
        console.log('Coupon Code:', data.couponCode);
        // Add your logic to apply the discount here
        const isConfirmed = await Swal.fire({
            title: 'Are you sure?',
            text: `You are about to apply the coupon code ${data.couponCode}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, apply it!',
            cancelButtonText: 'No, cancel!',
            allowOutsideClick: false,
        });
        if (isConfirmed.isConfirmed) {
            Swal.fire({
                title: 'Processing...',
                text: 'Please wait while we apply the discount.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
            try {

                const discountResponse = await BookingService.updatebookingTimeSlot({
                    "bookingId": bookingInProgressData?.id,
                    "timeSlotDate": bookingInProgressData?.serviceDate,
                    "startTime": bookingInProgressData.bookingStartTime,
                    "endTime": bookingInProgressData.bookingEndTime,
                    "useCoin": bookingInProgressData?.coinValue == '0'?false:true,
                    "couponCode": data.couponCode,
                });

                if (discountResponse.success == "1") {
                    if (discountResponse.data?.couponId == null) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: discountResponse.data.couponMsg?.msg || 'Coupon code is not valid or already used.',
                        });
                        const bookingDetails = await BookingService.bookingDetailById(bookingInProgressData?.id)
                        setBookingInProgressData(bookingDetails.data);
                        // Swal.close();
                        setOpenDiscountModal(false);
                        return;
                    }
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Discount applied successfully',
                    });
                    // setBookingInProgressData(discountResponse.data);
                    const bookingDetails = await BookingService.bookingDetailById(bookingInProgressData?.id)
                    setBookingInProgressData(bookingDetails.data);

                    Swal.close();
                    setOpenDiscountModal(false);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Invalid coupon code. Please try again.',
                    });
                }

            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Something Went wrong. Please try again.',
                });
                console.error("Error in applying discount coupon:", error);
            }
        }
    }
    // const subitCouponDiscount = async (data) => {
    //     console.log('Coupon Code:', data.couponCode);
    //     // Add your logic to apply the discount here
    //     const isConfirmed = await Swal.fire({
    //         title: 'Are you sure?',
    //         text: `You are about to apply the coupon code ${data.couponCode}`,
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonText: 'Yes, apply it!',
    //         cancelButtonText: 'No, cancel!',
    //         allowOutsideClick: false,
    //     });
    //     if (isConfirmed.isConfirmed) {
    //         // //processing the coupon code
    //         // Swal.fire({
    //         //     title: 'Processing...',
    //         //     text: 'Please wait while we apply the discount.',
    //         //     allowOutsideClick: false,
    //         //     didOpen: () => {
    //         //         Swal.showLoading();
    //         //     },
    //         // });
    //         // try {

    //         //     const timeSlotUpdateResponse = await BookingService.updatebookingTimeSlot({
    //         //         "bookingId": bookingInProgressData?.id,
    //         //         "timeSlotDate": bookingInProgressData?.serviceDate,
    //         //         "startTime": bookingInProgressData.bookingStartTime,
    //         //         "endTime": bookingInProgressData.bookingEndTime,
    //         //         "useCoin": bookingInProgressData?.useCoin,
    //         //         "couponCode": data.couponCode,
    //         //     });

    //         //     if (timeSlotUpdateResponse.success == "1") {
    //         //         setBookingInProgressData(timeSlotUpdateResponse.data);
    //         //         Swal.close();
    //         //     }
    //         // } catch (error) {
    //         //     Swal.fire({
    //         //         icon: 'error',
    //         //         title: 'Error',
    //         //         text: 'Something Went wrong. Please try again.',
    //         //     });
    //         //     console.error("Error in applying discount coupon:", error);
    //         // }

    //     } else {
    //         Swal.fire('Cancelled', 'Discount application cancelled.', 'info');
    //     }
    // }
    return (
        <Box sx={{ p: '2%' }} component={'form'} onSubmit={handleSubmit(subitCouponDiscount)}>
            {/* Add discount input and button here */}
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '2%', gap: 1 }}>
                <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>Enter Coupon Code :</Typography>
                <Controller
                    control={control}
                    name="couponCode"
                    rules={{
                        required: 'Enter Coupon Code',
                        // alphanumeric and maximum 12 characters
                        pattern: {
                            value: /^[a-zA-Z0-9]{1,12}$/,
                            message: 'Coupon Code must be alphanumeric and maximum 12 characters',
                        },
                    }}
                    render={({ field, fieldState: { error } }) => (
                        <TextField
                            {...field}
                            size='small'
                            variant='outlined'
                            placeholder='Enter Coupon Code'
                            // error={!!error}
                            // helperText={error ? error.message : ''}
                            InputProps={{
                                style: { fontSize: '0.75rem' }
                            }}
                            onChange={(e) => {
                                const value = e.target.value;
                                //uppercase the value and max length 12
                                const formattedValue = value.toUpperCase().slice(0, 12);
                                field.onChange(formattedValue);
                            }}
                        />
                    )}
                />
            </Box>
            {errors?.couponCode && (
                <Typography sx={{ color: '#d32f2f', fontSize: '.7rem', textAlign: 'center' }}>
                    {errors?.couponCode?.message}
                </Typography>
            )}
            <Box sx={{ textAlign: 'center' }}>
                <Button
                    size='small'
                    variant="contained"
                    color="primary"
                    sx={{ textTransform: 'none' }}
                    type='submit'
                >
                    Apply Discount
                </Button>
            </Box>
        </Box>
    )
}

export default ApplyDiscount